var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.writeFile()}}},[_vm._v(" Hello Site Map ")])
}
var staticRenderFns = []

export { render, staticRenderFns }